export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS'      : 'Applications',
            'DASHBOARDS'        : 'Dashboard',
            'SUPERADMIN'        : 'Administration',
            'ORGANIZATION'      : 'Organization',
            'MARKET'            : 'Market',
            'MARKET_LEVEL'      : 'Market Level',
            'USER_ROLE'         : 'User Role',
            'DISTRIBUTOR'       : 'Distributor',
            'DISTRIBUTION_CENTER': 'Distribution Center',
            'CUSTOMER'          : 'Customer',
            'PRODUCT'           : 'Product',
            'CAMPAIGN'          : 'Campaign',
            'ORDER'             : 'Order',
            'INVOICE'           : 'Invoice',
            'DELIVERY_CHALLAN'  : 'Delivery Challan',
            'MARKET_HIERARCHY'  : 'Market Structure',
            'USER'              : 'User',
            'TOUR_PLAN'         : 'Tour Plan',
            'BANK_ACCOUNT'      : 'Bank Account',
            'PAYMENT'           : 'Payment',
            'NOTICE'            : 'Notice',
            'ATTENDANCE'        : 'Attendance',
            'EXPENSE'           : 'Expense',
            'DAILY_TA_DA'       : 'Daily TA/DA',
            'HOLIDAY'           : 'Holiday',
            'LOCATION'          : 'Tracking',
            'RETURN'            : 'Return',
            'REPORT'            : 'Report',
            'TARGET_ACHIEVEMENT': 'Target Achievement',
            'VISIT'             : 'Visit'
        }
    }
};
